export default __webpack_public_path__ + "static/popup-kerst-2025-9a27737c65eca13e3b52fa36f5842380.png";